/**
 * Core Components
 *
 * @copyright (c) AQuest
 * @module base/common
 */

import debounce from 'lodash/debounce';

const MQ_BASE_BREAKPOINT = 'mobile';

class Common {

    constructor() {

        this.screen = {};

        this.userAgent = {

            // firefox
            firefox: !!navigator.userAgent.match(/firefox/i),

            // opera
            opera: !!window.opera || /opera|opr/i.test(navigator.userAgent),

            // ie >= 10
            ie: document.body.style.msTouchAction !== undefined,

            // chrome > 14 (09/2011)
            chrome: !!window.chrome && !!window.chrome.webstore,

            // safari
            safari: /constructor/i.test(window.HTMLElement)

        };

        this.initMqListnener();
    }

    _getMqStyle() {
        return (window.getComputedStyle(document.body, ':after').content || MQ_BASE_BREAKPOINT).replace(/['"]+/g, '');
    }

    _getMqMatrix() {
        let content = window.getComputedStyle(document.body, ':before').content,
            result;
        const parseRegExp = /\{?\\?"([a-z0-9\-]+)\\?":([0-9]+)/g;

        this._mqMatrix = new Map();

        while ((result = parseRegExp.exec(content)) !== null) {
            this._mqMatrix.set(result[1], parseInt(result[2], 10));
        }
    }

    _mqMin(mq) {
        const keys = [];
        for (let key of this._mqMatrix.keys()) {
            keys.push(key);
        }
        return keys.indexOf(mq) !== -1 ? keys.slice(0, keys.indexOf(mq) + 1) : [];
    }

    mq(mq) {
        return this._mqMin(this.currentMq).indexOf(mq) !== -1;
    }

    mqUntil(mq) {
        return this._mqMin(this.currentMq).indexOf(mq) === -1;
    }

    initMqListnener() {
        this.currentMq = this._getMqStyle();
        this._getMqMatrix();

        window.addEventListener('resize', debounce(() => {
            //read the style
            const newMq = this._getMqStyle();
            if (typeof newMq === 'string' && this.currentMq !== newMq) {
                this.currentMq = newMq;
            }
        }, 100));

    }

    getInfo() {

        this.screen.height = window.innerHeight || this.$window.height();
        this.screen.width = window.innerWidth || this.$window.width();
        this.screen.ratio = this.screen.height / this.screen.width;
    }

    isElementEntirelyInViewport(el) {

        const elm = (el instanceof jQuery) ? el[0] : el;

        const rect = elm.getBoundingClientRect();

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= this.screen.height &&
            rect.right <= this.screen.width
        );

    }

}

module.exports = new Common;


/** WEBPACK FOOTER **
 ** ./base/common.js
 **/